module.exports = __webpack_public_path__ + "static/hero-border-green-953174852088bbb4aadb538b3b6f0d47.svg";